// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3XhPJ","col":"styles_col__3APrs","fulfillmentStatus":"styles_fulfillmentStatus__3UzYs","emailCol":"styles_emailCol__dPtYH"};